module.exports = __webpack_public_path__ + "img/NP.2505419f.png";